import Auth from "./auth/reducers";
import Shop from "./shop/reducers";
import User from "./user/reducers";

export default {
  Auth,
  Shop,
  User,
};
